// Source: commanddeck-hq @ be1f879 · src/components/layout/AppLayout.tsx
// Modified for Reverra: removed ChatWidget (Lovable-AI gateway demo, not used).
import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import BackgroundOrbs from './BackgroundOrbs';
import AppSidebar from './AppSidebar';
import TopBar from './TopBar';
import { CommandPaletteProvider } from '@/components/CommandPalette';
import ErrorBoundary from '@/components/ErrorBoundary';

const AppLayout = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  return (
    <CommandPaletteProvider>
      <div className="min-h-screen relative">
        <BackgroundOrbs />
        <AppSidebar />
        <div className="ml-[240px] relative z-10 flex flex-col min-h-screen">
          <TopBar />
          <motion.main
            className="flex-1 px-6 lg:px-12 py-8 max-w-[1440px] mx-auto w-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            {/* Keyed by route so a page error resets when the owner navigates
                away; the sidebar/topbar stay mounted around the fallback. */}
            <ErrorBoundary key={pathname}>{children}</ErrorBoundary>
          </motion.main>
        </div>
      </div>
    </CommandPaletteProvider>
  );
};

export default AppLayout;
